import type { Category } from '@wix/add-panel-common';

interface UseGetScrollBIParamsProps {
  categories: Category[];
  categoriesListContainerRef: React.RefObject<HTMLDivElement>;
  categoriesListRef: React.RefObject<HTMLUListElement>;
  searchButtonRef: React.RefObject<HTMLButtonElement>;
  isEditorSearchButtonVisible?: boolean;
}

type UseGetScrollBIParamsResult = (categoryId: string) => {
  category_under_scroll: boolean;
  isScrollable: boolean | null;
  window_width: number;
  window_height: number;
};

export const useGetScrollBIParams =
  ({
    categories,
    categoriesListContainerRef,
    categoriesListRef,
    searchButtonRef,
    isEditorSearchButtonVisible = false,
  }: UseGetScrollBIParamsProps): UseGetScrollBIParamsResult =>
  (categoryId: string) => {
    if (!categoriesListRef.current || !categoriesListRef.current) {
      return {
        category_under_scroll: false,
        isScrollable: null,
        window_width: window.innerWidth,
        window_height: window.innerHeight,
      };
    }

    const frameHeight = categoriesListContainerRef.current?.clientHeight || 0;
    const listItemHeight = categoriesListRef.current?.firstElementChild?.clientHeight || 0;

    const searchButtonHeight = isEditorSearchButtonVisible ? searchButtonRef.current?.clientHeight || 0 : 0;

    const categoriesListStyle = getComputedStyle(categoriesListRef.current);
    const categoriesListPadding =
      parseFloat(categoriesListStyle.paddingTop) + parseFloat(categoriesListStyle.paddingBottom) || 0;

    const frameContentHeight = searchButtonHeight + categoriesListPadding + categories.length * listItemHeight;
    const isCategoriesListScrollable = frameContentHeight > frameHeight;

    const categoryIndex = categories.findIndex((listItem) => listItem.id === categoryId);
    const currentCategoryDistanceFromTop =
      parseFloat(categoriesListStyle.paddingTop || '0') + searchButtonHeight + categoryIndex * listItemHeight;

    const isCategoryUnderScroll = currentCategoryDistanceFromTop + 0.9 * listItemHeight > frameHeight;

    return {
      category_under_scroll: isCategoryUnderScroll,
      isScrollable: isCategoriesListScrollable,
      window_width: window.innerWidth,
      window_height: window.innerHeight,
    };
  };
